// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { IconTokens } from './type';

const iconTokens: IconTokens = {
  iconFontSize: 'Font-14',
  iconSmallFontSize: 'Font-12',
  iconLargeFontSize: 'Font-16',
  iconFontColor: 'inherit',
  iconPrimaryFontColor: 'Brand-6',
  iconSecondaryFontColor: 'Neutral-text-4',
  iconSuccessFontColor: 'Success-5',
  iconInfoFontColor: '#17a2b8',
  iconWarningFontColor: 'Warning-5',
  iconDangerFontColor: 'Danger-5',
};

export default iconTokens;
